import {Injectable} from '@angular/core';
import {HttpClient, HttpErrorResponse} from "@angular/common/http";
import {catchError} from "rxjs/operators";
import {BehaviorSubject, Observable, of} from "rxjs";
import {environment} from "../../../environments/environment";
import {SnackBarService} from "../../@core/services/snack-bar.service";
import {IUserShort} from "../../@core/interfaces/user/user.interface";

@Injectable({
  providedIn: 'root'
})
export class SearchUserService {

  public searchResult: BehaviorSubject<IUserShort[]> = new BehaviorSubject<IUserShort[]>([]);
  public searchResult$: Observable<IUserShort[]> = this.searchResult.asObservable();

  constructor(private readonly http: HttpClient,
              private sb: SnackBarService) {
  }

  searchUser(query: string, type: string): Observable<IUserShort[]> {
    return this.http.post<any>(`${environment.GATEWAY_URL}/user/search-user`, {identifier: query, type: type})
      .pipe(catchError((error: HttpErrorResponse) => this.onHandleError(error)))
  }

  private onHandleError(error: HttpErrorResponse): Observable<any> {
    const message = error.error.statusCode + ' ' + (error.error.message || error.error.error);
    this.sb.openSnackBar(message, 3000, 'error');
    return of([]);
  }

}
